<template>
  <v-card
    class="my-vcard-style"
    color="#ECEFF1"
  >
    <br>
    <h3 class="my-card-title-style">
      Report Summary
    </h3>
    <br>
    <v-simple-table>
      <thead>
        <tr>
          <th class="primary--text">
            Report Type
          </th>
          <th class="primary--text">
            Location
          </th>
          <th class="primary--text">
            Dispalyed From
          </th>
          <th class="primary--text">
            Displayed To
          </th>
          <th class="primary--text">
            Count
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(data, index ) in graphData"
          :key="index"
        >
          <td>{{ data.key }}</td>
          <td>{{ formData.digiLocation }}</td>
          <td>{{ formData.start | convertStringToLocalDatetime }}</td>
          <td>{{ formData.end | convertStringToLocalDatetime }}</td>
          <td>{{ data.doc_count }}</td>
        </tr>
      </tbody>
    </v-simple-table>
  </v-card>
</template>
<script>
  import moment from 'moment';

  export default {
    name: 'ReportSummary',
    filters: {
      convertStringToLocalDatetime (stringDatetime) {
        return moment(stringDatetime).local().format('Do MMMM YYYY hh:mm A');
      },
    },
    data: () => ({
    }),
    computed: {
      graphData () {
        return this.$store.getters['reports/getGraphData'];
      },
      formData () {
        return this.$store.getters['reports/getFormData'];
      },
    },
  };
</script>
<style scoped>
.my-vcard-style {
  border-radius: 15px;
  margin-right: 20px;
}
.my-card-title-style {
  color: #37474F;
  font-size: 18px;
  text-align: center;
}
.v-data-table::v-deep th {
  font-size: 12px !important;
  color: #37474F !important;
  font-weight: bold !important;
}
.v-data-table::v-deep td {
  font-size: 13px !important;
  color: #37474F !important;
}
.theme--light.v-data-table tbody tr:nth-of-type(even) {
  background-color: #CFD8DC
}
.v-data-table { background-color: #ECEFF1; }
</style>
